import { render, staticRenderFns } from "./baleDetail.vue?vue&type=template&id=63afcd4d&scoped=true&"
import script from "./baleDetail.vue?vue&type=script&lang=js&"
export * from "./baleDetail.vue?vue&type=script&lang=js&"
import style0 from "./baleDetail.vue?vue&type=style&index=0&id=63afcd4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63afcd4d",
  null
  
)

export default component.exports